import React, { useEffect, useState } from 'react'

import Script from 'dangerous-html/react'

import './component.css'

const AppComponent = (props) => {
  const publicUrl = process.env.PUBLIC_URL || ''
  const resumeUrl = `${publicUrl}/resume/PRASANGA%20CV.pdf`
  const [projectSlide, setProjectSlide] = useState(0)
  const [projectCarouselPaused, setProjectCarouselPaused] = useState(false)
  const [certificateSlide, setCertificateSlide] = useState(0)
  const [activeWorkTab, setActiveWorkTab] = useState('projects')

  useEffect(() => {
    if (projectCarouselPaused) {
      return undefined
    }

    const autoScroll = window.setInterval(() => {
      setProjectSlide((currentSlide) => (currentSlide + 1) % 3)
    }, 5000)

    return () => window.clearInterval(autoScroll)
  }, [projectCarouselPaused])

  return (
    <section className="component-container10">
      <nav id="top" className="component-thq-navbar-elm">
        <div className="nav-links">
          <a href="#resume" className="component-link10">
            <div>
              <span>Resume</span>
            </div>
          </a>
          <a href="#skills" className="component-link11">
            <div>
              <span>Skills</span>
            </div>
          </a>
          <a href="#projects-certifications" className="component-link12">
            <div>
              <span>Projects</span>
            </div>
          </a>
          <a href="#projects-certifications" className="component-link13">
            <div>
              <span>Certifications</span>
            </div>
          </a>
        </div>
        <a
          href={resumeUrl}
          target="_blank"
          rel="noreferrer noopener"
          className="component-link14"
        >
          <div className="nav-btn">
            <span>View Resume</span>
          </div>
        </a>
      </nav>
      <h1 className="component-thq-hero-name-elm">Prasanga Uprety</h1>
      <p className="component-thq-hero-intro-elm">
        I’m Prasanga Uprety, an AI enthusiast passionate about exploring
        intelligent systems and transforming emerging technology into
        thoughtful, practical digital experiences.
      </p>
      <img
        alt="Portrait of Prasanga Uprety"
        src={`${publicUrl}/functions/prasanga-profile-300w.jpg`}
        className="component-image10"
      />
      <div id="resume" className="component-container15">
        <cite className="component-thq-section-title-elm">Resume</cite>
        <div className="component-thq-blocks-wrapper-elm">
          <div className="component-thq-edu-block-elm">
            <h3 className="component-thq-block-heading-elm1 block-heading">
              Education
            </h3>
            <div className="edu-item">
              <div className="edu-role">
                <span className="component-text15">
                  <span>
                    College of Applied
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="component-text17">Business</span>
                </span>
              </div>
              <div className="edu-org">
                <span className="component-text18">Kathmandu, Nepal</span>
              </div>
              <div className="edu-time">
                <span className="component-text19">2023 – 2027</span>
              </div>
              <span className="component-text20">
                Pursuing a bachelor’s degree while building a strong foundation
                in technology, business, and practical problem-solving.
              </span>
            </div>
            <div className="edu-item">
              <div className="edu-role">
                <span className="component-text21">
                  Fuse Machines AI Fellowship
                </span>
              </div>
              <div className="edu-org">
                <span className="component-text22">Kathmandu, Nepal</span>
              </div>
              <div className="edu-time">
                <span className="component-text23">2025 – 2026</span>
              </div>
              <span className="component-text24">
                An applied AI fellowship focused on machine learning,
                intelligent systems, and building practical AI solutions.
              </span>
            </div>
          </div>
          <div className="component-thq-exp-block-elm">
            <h3 className="component-thq-block-heading-elm2 block-heading">
              Experience
            </h3>
            <div className="exp-item">
              <div className="exp-role">
                <span className="component-text25">Agentic AI Engineer</span>
              </div>
              <div className="exp-org">
                <span className="component-text26">
                  SmartChoice Technologies 
                </span>
              </div>
              <div className="exp-time">
                <span className="component-text27">
                  Apr 2026 – Jul 2026 · 4 months
                </span>
              </div>
              <div className="exp-loc">
                <span className="component-text28">
                  Kathmandu, Nepal · On-site
                </span>
              </div>
              <div className="exp-tags">
                <span className="component-text29">
                  At this fintech company, I built a LangChain document-indexing
                  pipeline and a local Ollama-powered chatbot. I also developed
                  an automated member-onboarding portal and worked with MCP
                  servers for attendance reporting and financial analysis.
                </span>
              </div>
            </div>
          </div>
        </div>
        <a
          href={resumeUrl}
          target="_blank"
          rel="noreferrer noopener"
          className="component-button button"
        >
          View My Resume
        </a>
      </div>
      <div id="skills" className="component-container16">
        <cite className="component-text30">Skills</cite>
        <div className="component-container17">
          <div className="component-container18">
            <img
              alt="LLM logo"
              src="https://huggingface.co/front/assets/huggingface_logo-noborder.svg"
              className="component-image11"
            />
            <span className="component-text31">LLM</span>
          </div>
          <div className="component-container19">
            <img
              alt="Machine Learning logo"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/scikitlearn/scikitlearn-original.svg"
              className="component-image12"
            />
            <span className="component-text32">Machine Learning</span>
          </div>
          <div className="component-container20">
            <img
              alt="Deep Learning logo"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/pytorch/pytorch-original.svg"
              className="component-image13"
            />
            <span className="component-text33">Deep Learning</span>
          </div>
          <div className="component-container21">
            <img
              alt="Python logo"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg"
              className="component-image14"
            />
            <span className="component-text34">Python</span>
          </div>
          <div className="component-container22">
            <img
              alt="Docker logo"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg"
              className="component-image15"
            />
            <span className="component-text35">Docker</span>
          </div>
          <div className="component-container23">
            <img
              alt="Django logo"
              src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/django/django-plain.svg"
              className="component-image16"
            />
            <span className="component-text36">Django</span>
          </div>
        </div>
      </div>
      <div className="component-container24">
        <div className="component-container25">
          <Script
            html={`<style>
#pu-tab-projects:checked ~ .pu-work-shell .pu-work-tab[for="pu-tab-projects"], #pu-tab-certifications:checked ~ .pu-work-shell .pu-work-tab[for="pu-tab-certifications"] {
  color: #FFF9F1;
}
#pu-tab-certifications:checked ~ .pu-work-shell .pu-work-switch-indicator {
  transform: translateX(100%);
  background: #7A584A;
}
#pu-tab-certifications:checked ~ .pu-work-shell .pu-work-title {
  color: #7A584A;
}
#pu-tab-certifications:checked ~ .pu-work-shell .pu-project-panel {
  display: none;
}
#pu-tab-certifications:checked ~ .pu-work-shell .pu-certificate-panel {
  display: block;
}
#pu-project-1:checked ~ .pu-project-viewport .pu-project-track {
  transform: translateX(0);
}
#pu-project-2:checked ~ .pu-project-viewport .pu-project-track {
  transform: translateX(-100%);
}
#pu-project-3:checked ~ .pu-project-viewport .pu-project-track {
  transform: translateX(-200%);
}
#pu-project-1:checked ~ .pu-project-dots label:nth-child(1), #pu-project-2:checked ~ .pu-project-dots label:nth-child(2), #pu-project-3:checked ~ .pu-project-dots label:nth-child(3) {
  width: 28px;
  background: #2F2A24;
}
#pu-cert-1:checked ~ .pu-cert-viewport .pu-cert-track {
  transform: translateX(0);
}
#pu-cert-2:checked ~ .pu-cert-viewport .pu-cert-track {
  transform: translateX(-100%);
}
#pu-cert-3:checked ~ .pu-cert-viewport .pu-cert-track {
  transform: translateX(-200%);
}
#pu-cert-4:checked ~ .pu-cert-viewport .pu-cert-track {
  transform: translateX(-300%);
}
#pu-cert-1:checked ~ .pu-cert-dots label:nth-child(1), #pu-cert-2:checked ~ .pu-cert-dots label:nth-child(2), #pu-cert-3:checked ~ .pu-cert-dots label:nth-child(3), #pu-cert-4:checked ~ .pu-cert-dots label:nth-child(4) {
  width: 28px;
  background: #7A584A;
}
</style>`}
          ></Script>
        </div>
      </div>
      <section id="projects-certifications" className="pu-work-section">
        <input
          type="radio"
          id="pu-tab-projects"
          name="pu-work-tab"
          checked={activeWorkTab === 'projects'}
          onChange={() => setActiveWorkTab('projects')}
          className="pu-sr-radio"
        />
        <input
          type="radio"
          id="pu-tab-certifications"
          name="pu-work-tab"
          checked={activeWorkTab === 'certifications'}
          onChange={() => setActiveWorkTab('certifications')}
          className="pu-sr-radio"
        />
        <cite className="component-thq-pu-work-title-elm pu-work-title">
          Projects
        </cite>
        <div className="pu-work-shell">
          <p className="pu-work-lead">
            Selected AI systems, experiments, and learning milestones.
          </p>
          <div
            role="tablist"
            aria-label="Projects and certifications"
            className="pu-work-switch"
          >
            <span className="pu-work-switch-indicator"></span>
            <label role="tab" htmlFor="pu-tab-projects" className="pu-work-tab">
              Projects
            </label>
            <label
              role="tab"
              htmlFor="pu-tab-certifications"
              className="pu-work-tab"
            >
              Certifications
            </label>
          </div>
          <div className="pu-project-panel pu-work-panel">
            <div
              className="pu-carousel pu-project-carousel"
              onMouseEnter={() => setProjectCarouselPaused(true)}
              onMouseLeave={() => setProjectCarouselPaused(false)}
              onFocusCapture={() => setProjectCarouselPaused(true)}
              onBlurCapture={() => setProjectCarouselPaused(false)}
            >
              <input
                type="radio"
                id="pu-project-1"
                name="pu-project-slide"
                checked={projectSlide === 0}
                onChange={() => setProjectSlide(0)}
                className="pu-sr-radio"
              />
              <input
                type="radio"
                id="pu-project-2"
                name="pu-project-slide"
                checked={projectSlide === 1}
                onChange={() => setProjectSlide(1)}
                className="pu-sr-radio"
              />
              <input
                type="radio"
                id="pu-project-3"
                name="pu-project-slide"
                checked={projectSlide === 2}
                onChange={() => setProjectSlide(2)}
                className="pu-sr-radio"
              />
              <div className="pu-project-viewport pu-carousel-viewport">
                <div className="pu-project-track pu-carousel-track">
                  <article className="pu-project-slide">
                    <div className="pu-project-card pu-project-quiz">
                      <div className="pu-project-copy">
                        <span className="pu-project-index">01 / 03</span>
                        <p className="pu-project-kicker">Generative AI · NLP</p>
                        <h3>AI Quiz Generator</h3>
                        <p className="pu-project-description">
                          An end-to-end educational NLP pipeline that transforms
                          context and answers into structured quiz questions
                          using a fine-tuned T5 transformer. The model-building
                          branch covers SQuAD and RACE preprocessing, T5
                          tokenization, mixed-precision training, evaluation,
                          and checkpointing.
                        </p>
                        <div className="pu-project-tags">
                          <span>T5</span>
                          <span>PyTorch</span>
                          <span>Transformers</span>
                          <span>NLP</span>
                        </div>
                        <a
                          href="https://github.com/fuseai-fellowship/Automatic-generation-of-quiz/tree/Model-Building"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="component-link15"
                        >
                          <div
                            rel="noopener"
                            target="_blank"
                            className="pu-project-link"
                          >
                            <span>
                              Explore the model-building branch
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ' ',
                                }}
                              />
                            </span>
                            <span>↗</span>
                          </div>
                        </a>
                      </div>
                      <div
                        aria-label="Abstract quiz generation visualization"
                        className="pu-project-visual pu-quiz-visual"
                      >
                        <div className="pu-orbit-one pu-orbit"></div>
                        <div className="pu-orbit pu-orbit-two"></div>
                        <div className="pu-quiz-sheet pu-sheet-back">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <div className="pu-quiz-sheet pu-sheet-front">
                          <b>AI</b>
                          <strong>?</strong>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                        <div className="pu-spark pu-spark-one">
                          <span>✦</span>
                        </div>
                        <div className="pu-spark-two pu-spark">
                          <span>✦</span>
                        </div>
                      </div>
                    </div>
                    <label
                      aria-label="Previous project"
                      htmlFor="pu-project-3"
                      className="pu-arrow-left pu-arrow"
                    >
                      ←
                    </label>
                    <label
                      aria-label="Next project"
                      htmlFor="pu-project-2"
                      className="pu-arrow-right pu-arrow"
                    >
                      →
                    </label>
                  </article>
                  <article className="pu-project-slide">
                    <div className="pu-project-card pu-project-nare">
                      <div className="pu-project-copy">
                        <span className="pu-project-index">02 / 03</span>
                        <p className="pu-project-kicker">
                          Reasoning Systems · Disaster Response
                        </p>
                        <h3>Neural Abstract Reasoning Engine</h3>
                        <p className="pu-project-description">
                          NARE turns natural-language emergency messages into
                          verified execution graphs. A DistilBERT router,
                          Transformer planner, dependency-complete SLR DAG, tool
                          executor, rule and Ollama verifier, and RL-assisted
                          abstraction layer work together behind a FastAPI and
                          React interface.
                        </p>
                        <div className="pu-project-tags">
                          <span>DistilBERT</span>
                          <span>RL</span>
                          <span>FastAPI</span>
                          <span>React</span>
                        </div>
                        <a
                          href="https://github.com/prasanga101/Neural-Abstract-Reasoning-Engine"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="component-link16"
                        >
                          <div
                            rel="noopener"
                            target="_blank"
                            className="pu-project-link"
                          >
                            <span>
                              View the reasoning engine
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ' ',
                                }}
                              />
                            </span>
                            <span>↗</span>
                          </div>
                        </a>
                      </div>
                      <div
                        aria-label="Animated reasoning graph visualization"
                        className="pu-nare-visual pu-project-visual"
                      >
                        <div className="pu-graph-line pu-line-a"></div>
                        <div className="pu-graph-line pu-line-b"></div>
                        <div className="pu-graph-line pu-line-c"></div>
                        <div className="pu-graph-line pu-line-d"></div>
                        <span className="pu-node-1 pu-node">R</span>
                        <span className="pu-node-2 pu-node">P</span>
                        <span className="pu-node-3 pu-node">SLR</span>
                        <span className="pu-node pu-node-4">E</span>
                        <span className="pu-node-5 pu-node">✓</span>
                        <div className="pu-graph-status">
                          <span>message → verified action</span>
                        </div>
                      </div>
                    </div>
                    <label
                      aria-label="Previous project"
                      htmlFor="pu-project-1"
                      className="pu-arrow-left pu-arrow"
                    >
                      ←
                    </label>
                    <label
                      aria-label="Next project"
                      htmlFor="pu-project-3"
                      className="pu-arrow-right pu-arrow"
                    >
                      →
                    </label>
                  </article>
                  <article className="pu-project-slide">
                    <div className="pu-project-calibration pu-project-card">
                      <div className="pu-project-copy">
                        <span className="pu-project-index">03 / 03</span>
                        <p className="pu-project-kicker">
                          AI Safety · Low-resource Languages
                        </p>
                        <h3>Know What You Don’t Know</h3>
                        <p className="pu-project-description">
                          LRCal-Agent studies whether multilingual LLMs can
                          recognize uncertainty in Nepali and English QA. It
                          separates calibration signals from an action policy
                          that learns when to translate, retrieve, repair, or
                          abstain—while explicitly measuring generation-fidelity
                          failures and position bias.
                        </p>
                        <div className="pu-project-tags">
                          <span>Calibration</span>
                          <span>Nepali NLP</span>
                          <span>Ollama</span>
                          <span>AI Safety</span>
                        </div>
                        <a
                          href="https://github.com/prasanga101/know-what-you-dont-know"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="component-link17"
                        >
                          <div
                            rel="noopener"
                            target="_blank"
                            className="pu-project-link"
                          >
                            <span>
                              Read the research repository
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ' ',
                                }}
                              />
                            </span>
                            <span>↗</span>
                          </div>
                        </a>
                      </div>
                      <div
                        aria-label="Calibrated action policy visualization"
                        className="pu-calibration-visual pu-project-visual"
                      >
                        <div className="pu-gauge">
                          <div className="pu-gauge-ring"></div>
                          <div className="pu-gauge-hand"></div>
                          <div className="pu-gauge-core">
                            <span>?</span>
                          </div>
                        </div>
                        <div className="pu-action-cloud">
                          <span>TRANSLATE</span>
                          <span>RETRIEVE</span>
                          <span>REPAIR</span>
                          <span>ABSTAIN</span>
                        </div>
                      </div>
                    </div>
                    <label
                      aria-label="Previous project"
                      htmlFor="pu-project-2"
                      className="pu-arrow-left pu-arrow"
                    >
                      ←
                    </label>
                    <label
                      aria-label="Next project"
                      htmlFor="pu-project-1"
                      className="pu-arrow-right pu-arrow"
                    >
                      →
                    </label>
                  </article>
                </div>
              </div>
              <div
                aria-label="Project slides"
                className="pu-carousel-dots pu-project-dots"
              >
                <label aria-label="Project 1" htmlFor="pu-project-1"></label>
                <label aria-label="Project 2" htmlFor="pu-project-2"></label>
                <label aria-label="Project 3" htmlFor="pu-project-3"></label>
              </div>
            </div>
          </div>
          <div className="pu-certificate-panel pu-work-panel">
            <div className="pu-certificate-carousel pu-carousel">
              <input
                type="radio"
                id="pu-cert-1"
                name="pu-cert-slide"
                checked={certificateSlide === 0}
                onChange={() => setCertificateSlide(0)}
                className="pu-sr-radio"
              />
              <input
                type="radio"
                id="pu-cert-2"
                name="pu-cert-slide"
                checked={certificateSlide === 1}
                onChange={() => setCertificateSlide(1)}
                className="pu-sr-radio"
              />
              <input
                type="radio"
                id="pu-cert-3"
                name="pu-cert-slide"
                checked={certificateSlide === 2}
                onChange={() => setCertificateSlide(2)}
                className="pu-sr-radio"
              />
              <input
                type="radio"
                id="pu-cert-4"
                name="pu-cert-slide"
                checked={certificateSlide === 3}
                onChange={() => setCertificateSlide(3)}
                className="pu-sr-radio"
              />
              <div className="pu-cert-viewport pu-carousel-viewport">
                <div className="pu-cert-track pu-carousel-track">
                  <article className="pu-cert-slide">
                    <div className="pu-cert-card">
                      <div className="pu-cert-image-wrap">
                        <img
                          alt="Introduction to Generative AI certificate"
                          src="https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~JNNGXQMAW7DM/CERTIFICATE_LANDING_PAGE~JNNGXQMAW7DM.jpeg"
                        />
                      </div>
                      <div className="pu-cert-copy">
                        <div>
                          <span>Google Cloud · Jan 30, 2024</span>
                          <h3>Introduction to Generative AI</h3>
                        </div>
                        <a
                          href="https://www.coursera.org/account/accomplishments/verify/JNNGXQMAW7DM"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="component-link18"
                        >
                          <div rel="noopener" target="_blank">
                            <span>Verify credential ↗</span>
                          </div>
                        </a>
                      </div>
                    </div>
                    <label
                      aria-label="Previous certificate"
                      htmlFor="pu-cert-4"
                      className="pu-arrow-left pu-arrow"
                    >
                      ←
                    </label>
                    <label
                      aria-label="Next certificate"
                      htmlFor="pu-cert-2"
                      className="pu-arrow-right pu-arrow"
                    >
                      →
                    </label>
                  </article>
                  <article className="pu-cert-slide">
                    <div className="pu-cert-card">
                      <div className="pu-cert-image-wrap">
                        <img
                          alt="Advanced Learning Algorithms certificate"
                          src="https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~HHZ25S56EZJE/CERTIFICATE_LANDING_PAGE~HHZ25S56EZJE.jpeg"
                        />
                      </div>
                      <div className="pu-cert-copy">
                        <div>
                          <span>
                            DeepLearning.AI &amp; Stanford · Jan 20, 2024
                          </span>
                          <h3>Advanced Learning Algorithms</h3>
                        </div>
                        <a
                          href="https://www.coursera.org/account/accomplishments/verify/HHZ25S56EZJE"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="component-link19"
                        >
                          <div rel="noopener" target="_blank">
                            <span>Verify credential ↗</span>
                          </div>
                        </a>
                      </div>
                    </div>
                    <label
                      aria-label="Previous certificate"
                      htmlFor="pu-cert-1"
                      className="pu-arrow-left pu-arrow"
                    >
                      ←
                    </label>
                    <label
                      aria-label="Next certificate"
                      htmlFor="pu-cert-3"
                      className="pu-arrow-right pu-arrow"
                    >
                      →
                    </label>
                  </article>
                  <article className="pu-cert-slide">
                    <div className="pu-cert-card">
                      <div className="pu-cert-image-wrap">
                        <img
                          alt="Supervised Machine Learning certificate"
                          src="https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~DS6RF67HTT4P/CERTIFICATE_LANDING_PAGE~DS6RF67HTT4P.jpeg"
                        />
                      </div>
                      <div className="pu-cert-copy">
                        <div>
                          <span>
                            DeepLearning.AI &amp; Stanford · Jan 7, 2024
                          </span>
                          <h3>Supervised Machine Learning</h3>
                        </div>
                        <a
                          href="https://www.coursera.org/account/accomplishments/verify/DS6RF67HTT4P"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="component-link20"
                        >
                          <div rel="noopener" target="_blank">
                            <span>Verify credential ↗</span>
                          </div>
                        </a>
                      </div>
                    </div>
                    <label
                      aria-label="Previous certificate"
                      htmlFor="pu-cert-2"
                      className="pu-arrow-left pu-arrow"
                    >
                      ←
                    </label>
                    <label
                      aria-label="Next certificate"
                      htmlFor="pu-cert-4"
                      className="pu-arrow-right pu-arrow"
                    >
                      →
                    </label>
                  </article>
                  <article className="pu-cert-slide">
                    <div className="pu-cert-aws pu-cert-card">
                      <div className="pu-cert-image-wrap">
                        <img
                          alt="AWS Academy Graduate Cloud Foundations badge"
                          src="https://images.credly.com/images/e3541a0c-dd4a-4820-8052-5001006efc85/linkedin_thumb_blob"
                        />
                      </div>
                      <div className="pu-cert-copy">
                        <div>
                          <span>AWS Academy · Jan 10, 2024</span>
                          <h3>AWS Academy Cloud Foundations</h3>
                        </div>
                        <a
                          href="https://www.credly.com/badges/588cc342-53cb-40f7-8563-54dde4bc3adb/linked_in_profile"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="component-link21"
                        >
                          <div rel="noopener" target="_blank">
                            <span>Verify credential ↗</span>
                          </div>
                        </a>
                      </div>
                    </div>
                    <label
                      aria-label="Previous certificate"
                      htmlFor="pu-cert-3"
                      className="pu-arrow-left pu-arrow"
                    >
                      ←
                    </label>
                    <label
                      aria-label="Next certificate"
                      htmlFor="pu-cert-1"
                      className="pu-arrow-right pu-arrow"
                    >
                      →
                    </label>
                  </article>
                </div>
              </div>
              <div
                aria-label="Certificate slides"
                className="pu-carousel-dots pu-cert-dots"
              >
                <label aria-label="Certificate 1" htmlFor="pu-cert-1"></label>
                <label aria-label="Certificate 2" htmlFor="pu-cert-2"></label>
                <label aria-label="Certificate 3" htmlFor="pu-cert-3"></label>
                <label aria-label="Certificate 4" htmlFor="pu-cert-4"></label>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="component-container34">
        <div className="component-container35">
          <Script
            html={`<style>
        @keyframes pu-panel-in {from {opacity: 0;
transform: translateY(18px);}
to {opacity: 1;
transform: translateY(0);}}@keyframes pu-spin {to {transform: rotate(360deg);}}@keyframes pu-float {0%,100% {transform: translate(-42%,-52%) rotate(5deg);}
50% {transform: translate(-42%,-57%) rotate(3deg);}}@keyframes pu-pulse {0%,100% {opacity: .45;
transform: scale(.8);}
50% {opacity: 1;
transform: scale(1.18);}}@keyframes pu-line-glow {0%,100% {opacity: .35;}
50% {opacity: 1;
box-shadow: 0 0 14px #D9EDB6;}}@keyframes pu-node-breathe {50% {transform: translateY(-8px);
box-shadow: 0 0 0 14px rgba(229,241,205,.08),0 20px 36px rgba(0,0,0,.24);}}@keyframes pu-meter {0%,100% {transform: rotate(-45deg);}
50% {transform: rotate(55deg);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <footer id="contact" className="component-thq-pu-footer-elm pu-footer">
        <div className="component-thq-pu-footer-shell-elm pu-footer-shell">
          <div className="pu-footer-main">
            <div className="pu-footer-intro">
              <p className="pu-footer-kicker">
                LET’S BUILD SOMETHING THOUGHTFUL
              </p>
              <h2>
                <span>Prasanga</span>
                <br></br>
              </h2>
              <a href="mailto:prasangauprety2@gmail.com?subject=">
                <div className="pu-footer-email">
                  <span>
                    prasangauprety2@gmail.com
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>↗</span>
                </div>
              </a>
            </div>
            <div aria-label="Social profiles" className="pu-social-grid">
              <a
                href="https://www.instagram.com/prasanga.uprety/"
                target="_blank"
                rel="noreferrer noopener"
                className="component-link23"
              >
                <div rel="noopener" target="_blank" className="pu-social-link">
                  <span className="pu-social-icon">
                    <img
                      alt="Instagram logo"
                      src="https://cdn.simpleicons.org/instagram/FFF8EE"
                    />
                  </span>
                  <span className="pu-social-copy">
                    <span>Follow on</span>
                    <span className="component-text98">Instagram</span>
                  </span>
                  <span className="pu-social-arrow">↗</span>
                </div>
              </a>
              <a
                href="https://www.linkedin.com/in/prasanga-uprety/"
                target="_blank"
                rel="noreferrer noopener"
                className="component-link24"
              >
                <div rel="noopener" target="_blank" className="pu-social-link">
                  <span className="pu-social-icon">
                    <img
                      alt="LinkedIn logo"
                      src="https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/linkedin.svg"
                    />
                  </span>
                  <span className="pu-social-copy">
                    <span>Connect on</span>
                    <span className="component-text100">LinkedIn</span>
                  </span>
                  <span className="pu-social-arrow">↗</span>
                </div>
              </a>
              <a
                href="https://www.facebook.com/prasanga.uprety.03/"
                target="_blank"
                rel="noreferrer noopener"
                className="component-link25"
              >
                <div rel="noopener" target="_blank" className="pu-social-link">
                  <span className="pu-social-icon">
                    <img
                      alt="Facebook logo"
                      src="https://cdn.simpleicons.org/facebook/FFF8EE"
                    />
                  </span>
                  <span className="pu-social-copy">
                    <span>Find me on</span>
                    <span className="component-text102">Facebook</span>
                  </span>
                  <span className="pu-social-arrow">↗</span>
                </div>
              </a>
              <a
                href="https://github.com/prasanga101"
                target="_blank"
                rel="noreferrer noopener"
                className="component-link26"
              >
                <div rel="noopener" target="_blank" className="pu-social-link">
                  <span className="pu-social-icon">
                    <img
                      alt="GitHub logo"
                      src="https://cdn.simpleicons.org/github/FFF8EE"
                    />
                  </span>
                  <span className="pu-social-copy">
                    <span>Explore on</span>
                    <span className="component-text104">GitHub</span>
                  </span>
                  <span className="pu-social-arrow">↗</span>
                </div>
              </a>
            </div>
          </div>
          <div className="pu-footer-divider"></div>
          <div className="pu-footer-bottom">
            <p>© 2026 Prasanga Uprety. Crafted with curiosity.</p>
            <a href="#top" className="component-link27">
              <div className="pu-back-top">
                <span>
                  Back to top
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span>↑</span>
              </div>
            </a>
          </div>
        </div>
      </footer>
      <div className="component-container36">
        <div className="component-container37">
          <Script
            html={`<style>
html {
  scroll-behavior: smooth;
}
</style>`}
          ></Script>
        </div>
      </div>
    </section>
  )
}

export default AppComponent
